import React, { useEffect } from "react";
import useTableCtx from "../tableContext/useTableCtx";

function FilterTable({
  value,
  withFilter,
  minW,
}: {
  value: string;
  minW?: number | string;
  withFilter: {
    value: string | number;
    label: string | number;
  }[];
}) {
  const { handleTableSearch, tableSearch } = useTableCtx()!;

  const tableSearchValue = tableSearch?.[value];
  const selectedValue = tableSearchValue ?? null;

  useEffect(() => {
    if (value && !tableSearchValue) {
      handleTableSearch(value, withFilter[0].value);
    }
  }, [value, withFilter, tableSearchValue, handleTableSearch]);

  const onFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleTableSearch(e.target.name, e.target.value);
  };

  return (
    <div>
      {selectedValue !== null && (
        <select
          name={value}
          data-control={`select-${value}`}
          data-hide-search="true"
          style={{ minWidth: minW ?? 130 }}
          className={`form-select form-select-sm form-select-solid bg-white`}
          value={selectedValue}
          onChange={onFilterChange}>
          {withFilter.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}

export default FilterTable;
